import { qs, qsa, pad, getScrollOffset, createScrollLock } from "../inc/dom.js";

const MORE_RESERVE = 130;

const initFeatured = () => {
    const track = qs("[data-featured-track]");
    if (!track) return;
    const slides = qsa("[data-featured-slide]", track);
    const sideItems = qsa("[data-featured-side]");
    const pagination = qs("[data-featured-pagination]");
    if (slides.length < 2) {
        if (pagination) pagination.hidden = true;
        return;
    }
    const count = qs("[data-featured-count]");
    const prev = qs("[data-featured-prev]");
    const next = qs("[data-featured-next]");
    let index = 0;

    const render = () => {
        slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
        sideItems.forEach((item, i) => {
            item.hidden = i === index;
        });
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
    };

    if (prev) {
        prev.addEventListener("click", () => {
            if (index === 0) return;
            index -= 1;
            render();
        });
    }
    if (next) {
        next.addEventListener("click", () => {
            if (index === slides.length - 1) return;
            index += 1;
            render();
        });
    }
    render();
};

const initCatMore = () => {
    const wrap = qs("[data-page-nav-links]");
    const more = qs("[data-page-nav-more]");
    if (!wrap || !more) return;
    const menu = qs("[data-page-nav-more-menu]", more);
    const toggle = qs("[data-page-nav-more-toggle]", more);
    const links = qsa(".page-nav-link", wrap);
    if (!menu || !toggle || !links.length) return;

    const layout = () => {
        more.hidden = true;
        more.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        menu.textContent = "";
        links.forEach((link) => {
            link.hidden = false;
        });

        const available = wrap.clientWidth;
        if (!available) return;

        const gap = parseFloat(getComputedStyle(wrap).columnGap) || 0;
        const widths = links.map((link) => link.offsetWidth);
        const fits = (n, reserve) => {
            if (!n) return true;
            const total = widths.slice(0, n).reduce((a, b) => a + b, 0) + (n - 1) * gap;
            return total + reserve <= available;
        };

        if (fits(links.length, 0)) return;

        let visible = links.length;
        while (visible > 0 && !fits(visible, gap + MORE_RESERVE)) {
            visible -= 1;
        }

        links.slice(visible).forEach((link) => {
            link.hidden = true;
            const href = link.getAttribute("href");
            const item = document.createElement(href ? "a" : "button");
            if (href) {
                item.setAttribute("href", href);
            } else {
                item.type = "button";
                const target = link.getAttribute("data-target");
                if (target) item.setAttribute("data-target", target);
            }
            item.className = "page-nav-more-item";
            item.textContent = link.textContent.trim();
            menu.appendChild(item);
        });
        more.hidden = false;
    };

    toggle.addEventListener("click", (event) => {
        event.stopPropagation();
        more.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", more.classList.contains("is-open"));
    });

    document.addEventListener("click", () => {
        more.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
    });

    layout();
    window.addEventListener("resize", layout, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
};

const scrollToSection = (id) => {
    const target = document.getElementById(id);
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
    window.scrollTo({ top, behavior: "smooth" });
};

const initCategoryNav = () => {
    const select = qs("[data-page-nav-select-input]");
    const scrollLock = createScrollLock();

    const setActive = (id) => {
        qsa("[data-page-nav-link]").forEach((link) => {
            link.classList.toggle("is-active", link.getAttribute("data-target") === id);
        });
        if (select && select.value !== id) select.value = id;
    };

    const jumpTo = (id) => {
        if (!document.getElementById(id)) return;
        scrollLock.lock();
        setActive(id);
        scrollToSection(id);
    };

    document.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-target]");
        if (!trigger) return;
        jumpTo(trigger.getAttribute("data-target"));
    });

    if (select) {
        select.addEventListener("change", () => jumpTo(select.value));
    }

    const sections = qsa("[data-page-section]");
    if (!sections.length || !("IntersectionObserver" in window)) return;

    const io = new IntersectionObserver(
        (entries) => {
            if (scrollLock.isLocked()) return;
            entries.forEach((entry) => {
                if (entry.isIntersecting) setActive(entry.target.id);
            });
        },
        { rootMargin: "-30% 0px -55% 0px" }
    );
    sections.forEach((section) => io.observe(section));
};

const initCategoryJump = () => {
    const select = qs("[data-page-nav-jump]");
    if (!select) return;
    select.addEventListener("change", () => {
        if (select.value) window.location.href = select.value;
    });
};

initFeatured();
initCatMore();
initCategoryNav();
initCategoryJump();
